import Measurer from './Measurer';
import * as is from 'Misc/is';
import { now } from 'Misc/timing';
import { update } from 'Emitter';
import { VIEWABILITY, MEASUREMENT } from 'StateEvents';
import { VIEWABLE, UNVIEWABLE } from './ViewabilityStates';
import { VIEWABLE_VIDEO_VIEW } from './ViewableCriteria.json';

export default class ViewabilityMeasurer extends Measurer {
  constructor() {
    super();
    this.resetTimeInView();
    this.inViewDuration = 0;
  }

  onUpdate(nextState, prevState, changes) {
    super.onUpdate(nextState, prevState, changes);

    if(this.isViewable(nextState)) {
      this.updateInviewDuration();

      if(!nextState.viewability.viewable) {
        update(VIEWABILITY.VIEWABLE, 'onUpdate', true);
      }
    } else {
      this.resetTimeInView();

      if(nextState.viewability.viewable) {
        update(VIEWABILITY.VIEWABLE, 'onUpdate', false);
      }
    }

    if(this.criteriaMet && !nextState.measurement.viewable) {
      this.queueRequests(nextState.configuration.Events.viewable, MEASUREMENT.VIEWABILITY_ACHIEVED, nextState.viewability.snapshot);
    }

    if(changes.viewability.unmeasureable && nextState.viewability.unmeasureable && !nextState.measurement.viewability_unsupported) {
      this.queueRequests(nextState.configuration.Events.viewability_unsupported, MEASUREMENT.VIEWABILITY_UNSUPPORTED);
    }
  }

  resetTimeInView() {
    this.lastTimeViewable = -1;
  }

  updateInviewDuration() {
    this.inViewDuration += this.lastTimeViewable > 0 ? now() - this.lastTimeViewable : 0;
    this.lastTimeViewable = now();
  }

  isViewable({ viewability }) {
    return viewability.snapshot.viewabilityState === VIEWABLE && viewability.snapshot.focus && !document.hidden;
  }

  get criteriaMet() {
    return this.inViewDuration >= VIEWABLE_VIDEO_VIEW.DURATION;
  }
}


// WEBPACK FOOTER //
// ./src/Services/Measurement/ViewabilityMeasurer.js